import { buildsServiceApi } from "../../api";

export interface GetProjectUserRequest {
  projectId: string;
  projectParticipantId?: string;
  userEmail?: string;
  page?: number;
  limit?: number;
}

type CompanyShortInfo = {
  companyId: string;
  userCompaniesHistoryId?: string;
  shortName: string;
  position: string;
};

export type UserInfo = {
  userId: string;
  userFirstName: string;
  userSurname: string;
  userMiddleName: string;
  userMobilePhone: string;
  userEmail: string;
  userAvatarId: string;
  userCompanies: Array<CompanyShortInfo>;
  isBlock: boolean;
};

interface GetProjectUserResponse {
  total: number;
  page: number;
  limit: number;
  projectId: string;
  userInfo: Array<UserInfo>;
}

export async function getProjectUser({
  projectId,
  ...params
}: GetProjectUserRequest): Promise<GetProjectUserResponse> {
  const r = await buildsServiceApi.get<GetProjectUserResponse>(
    `/projects/${projectId}/user`,
    {
      params,
    },
  );
  return r.data;
}
